<div [id]="id" class="ngb-tp">
  <div class="ngb-tp-input-container ngb-tp-hour">
    <button
      *ngIf="spinners"
      tabindex="-1"
      type="button"
      (click)="changeHour(hourStep)"
      class="btn btn-link"
      [class.btn-sm]="isSmallSize"
      [class.btn-lg]="isLargeSize"
      [class.disabled]="disabled"
      [disabled]="disabled"
    >
      <span class="chevron ngb-tp-chevron"></span>
      <span class="sr-only" i18n="@@ngb.timepicker.increment-hours">Increment hours</span>
    </button>
    <input
      data-testId="hour-picker"
      type="text"
      class="ngb-tp-input form-control e-input text-right"
      [class.form-control-sm]="isSmallSize"
      [class.form-control-lg]="isLargeSize"
      maxlength="2"
      inputmode="numeric"
      placeholder="HH"
      i18n-placeholder="@@ngb.timepicker.HH"
      [value]="formatHour(model?.hour)"
      [readOnly]="readonlyInputs"
      [disabled]="disabled"
      aria-label="Hours"
      i18n-aria-label="@@ngb.timepicker.hours"
      (blur)="handleBlur(); updateHour($any($event).target.value)"
      (input)="formatHourInput($any($event).target)"
      (keydown.ArrowUp)="changeHour(hourStep); $event.preventDefault(); $event.stopPropagation()"
      (keydown.ArrowDown)="changeHour(-hourStep); $event.preventDefault(); $event.stopPropagation()"
      (keydown.ArrowRight)="minuteInput.select(); minuteInput.setSelectionRange(0, 2); resetTempValues(); $event.preventDefault(); $event.stopPropagation()"
      (wheel)="disabled ? $event.preventDefault() : changeHour(-$event.deltaY > 0 ? hourStep : -hourStep); $event.preventDefault()"
      #hourInput
      (click)="hourInput.select(); hourInput.setSelectionRange(0, 2)"
    />
    <button
      *ngIf="spinners"
      tabindex="-1"
      type="button"
      (click)="changeHour(-hourStep)"
      class="btn btn-link"
      [class.btn-sm]="isSmallSize"
      [class.btn-lg]="isLargeSize"
      [class.disabled]="disabled"
      [disabled]="disabled"
    >
      <span class="chevron ngb-tp-chevron bottom"></span>
      <span class="sr-only" i18n="@@ngb.timepicker.decrement-hours">Decrement hours</span>
    </button>
  </div>
  <div class="ngb-tp-spacer">:</div>
  <div class="ngb-tp-input-container ngb-tp-minute">
    <button
      *ngIf="spinners"
      tabindex="-1"
      type="button"
      (click)="changeMinute(minuteStep)"
      class="btn btn-link"
      [class.btn-sm]="isSmallSize"
      [class.btn-lg]="isLargeSize"
      [class.disabled]="disabled"
      [disabled]="disabled"
    >
      <span class="chevron ngb-tp-chevron"></span>
      <span class="sr-only" i18n="@@ngb.timepicker.increment-minutes">Increment minutes</span>
    </button>
    <input
      data-testId="minutes-picker"
      type="text"
      class="ngb-tp-input form-control e-input text-left"
      [class.form-control-sm]="isSmallSize"
      [class.form-control-lg]="isLargeSize"
      maxlength="2"
      inputmode="numeric"
      placeholder="MM"
      i18n-placeholder="@@ngb.timepicker.MM"
      [value]="formatMinSec(model?.minute)"
      [readOnly]="readonlyInputs"
      [disabled]="disabled"
      aria-label="Minutes"
      i18n-aria-label="@@ngb.timepicker.minutes"
      (blur)="handleBlur(); updateMinute($any($event).target.value);"
      (input)="formatMinuteInput($any($event).target)"
      (keydown.ArrowUp)="changeMinute(minuteStep); $event.preventDefault(); $event.stopPropagation()"
      (keydown.ArrowDown)="changeMinute(-minuteStep); $event.preventDefault(); $event.stopPropagation()"
      (keydown.ArrowLeft)="hourInput.select(); hourInput.setSelectionRange(0, 2); resetTempValues(); $event.preventDefault(); $event.stopPropagation()"
      (wheel)="disabled ? $event.preventDefault() : changeMinute(-$event.deltaY > 0 ? minuteStep : -minuteStep); $event.preventDefault()"
      #minuteInput
      (click)="minuteInput.select(); minuteInput.setSelectionRange(0, 2)"
    />
    <button
      *ngIf="spinners"
      tabindex="-1"
      type="button"
      (click)="changeMinute(-minuteStep)"
      class="btn btn-link"
      [class.btn-sm]="isSmallSize"
      [class.btn-lg]="isLargeSize"
      [class.disabled]="disabled"
      [disabled]="disabled"
    >
      <span class="chevron ngb-tp-chevron bottom"></span>
      <span class="sr-only" i18n="@@ngb.timepicker.decrement-minutes">Decrement minutes</span>
    </button>
  </div>
  <div *ngIf="seconds" class="ngb-tp-spacer">:</div>
  <div *ngIf="seconds" class="ngb-tp-input-container ngb-tp-second">
    <button
      *ngIf="spinners"
      tabindex="-1"
      type="button"
      (click)="changeSecond(secondStep)"
      class="btn btn-link"
      [class.btn-sm]="isSmallSize"
      [class.btn-lg]="isLargeSize"
      [class.disabled]="disabled"
      [disabled]="disabled"
    >
      <span class="chevron ngb-tp-chevron"></span>
      <span class="sr-only" i18n="@@ngb.timepicker.increment-seconds">Increment seconds</span>
    </button>
    <input
      type="text"
      class="ngb-tp-input form-control"
      [class.form-control-sm]="isSmallSize"
      [class.form-control-lg]="isLargeSize"
      maxlength="2"
      inputmode="numeric"
      placeholder="SS"
      i18n-placeholder="@@ngb.timepicker.SS"
      [value]="formatMinSec(model?.second)"
      [readOnly]="readonlyInputs"
      [disabled]="disabled"
      aria-label="Seconds"
      i18n-aria-label="@@ngb.timepicker.seconds"
      (blur)="handleBlur(); updateSecond($any($event).target.value)"
      (input)="formatSecondInput($any($event).target)"
      (keydown.ArrowUp)="changeSecond(secondStep); $event.preventDefault(); $event.stopPropagation()"
      (keydown.ArrowDown)="changeSecond(-secondStep); $event.preventDefault(); $event.stopPropagation()"
    />
    <button
      *ngIf="spinners"
      tabindex="-1"
      type="button"
      (click)="changeSecond(-secondStep)"
      class="btn btn-link"
      [class.btn-sm]="isSmallSize"
      [class.btn-lg]="isLargeSize"
      [class.disabled]="disabled"
      [disabled]="disabled"
    >
      <span class="chevron ngb-tp-chevron bottom"></span>
      <span class="sr-only" i18n="@@ngb.timepicker.decrement-seconds">Decrement seconds</span>
    </button>
  </div>
  <div *ngIf="meridian" class="ngb-tp-spacer"></div>
  <div *ngIf="meridian" class="ngb-tp-meridian">
    <button
      type="button"
      class="btn btn-outline-primary"
      [class.btn-sm]="isSmallSize"
      [class.btn-lg]="isLargeSize"
      [disabled]="disabled"
      [class.disabled]="disabled"
      (click)="toggleMeridian()"
    >
      <ng-container *ngIf="model && model.hour >= 12; else am" i18n="@@ngb.timepicker.PM">
        {{ i18n.getAfternoonPeriod() }}
      </ng-container>
      <ng-template #am i18n="@@ngb.timepicker.AM">{{ i18n.getMorningPeriod() }}</ng-template>
    </button>
  </div>
</div>
